import { render, staticRenderFns } from "./tiers-modal.vue?vue&type=template&id=16f1f82a"
import script from "./tiers-modal.vue?vue&type=script&lang=js"
export * from "./tiers-modal.vue?vue&type=script&lang=js"
import style0 from "./tiers-modal.vue?vue&type=style&index=0&id=16f1f82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports